const productGalleryCarousel = class extends HTMLElement {
  constructor () {
    super()
    this.parentProductEl = this.closest('product-wrap')
    this.isQuickshop = this.parentProductEl.classList.contains('product--quickshop')
    this.slideEls = this.querySelectorAll('[data-product-gallery-slide]')
    this.mediaEls = this.querySelectorAll('[data-product-media-item]')
    this.isFilterItemsByColor = this.getAttribute('data-filter-by-color')
    this.colorOptionIndex = this.getAttribute('data-color-option-index')
    this.filteredSlides = [...this.slideEls]
    this.swiper = null
    this.variantData = {}
  }

  initCarouselGallery () {
    if (this.isFilterItemsByColor === 'true') {
      this.filteredSlides = this.filterItemsByColor()

      if (this.filteredSlides.length) {
        const filteredItemIds = this.filteredSlides.map(slide => slide.dataset.mediaId)

        this.slideEls.forEach(slideEl => {
          slideEl.classList.remove('hide')
          if (!filteredItemIds.includes(slideEl.dataset.mediaId)) {
            slideEl.remove()
          }
        })
      }
    } else {
      this.slideEls.forEach(slideEl => {
        slideEl.classList.remove('hide')
      })
    }

    this.swiper = this.initSwiper()
  }

  filterItemsByColor () {
    const variantColor = this.variantData[`option${this.colorOptionIndex}`]
    if (!variantColor) { return [...this.slideEls] }

    return [...this.slideEls].filter(slide => {
      const slideAltSplit = slide.dataset.altText.split('|')
      const slideColor = slideAltSplit.length > 1 ? slideAltSplit[0].trim() : false
      const showItem = !slideColor || slideColor.toLowerCase() === variantColor.toLowerCase()

      return showItem
    })
  }

  initSwiper () {
    const paginationEl = this.querySelector('[data-product-gallery-pagination]')

    const swiperOptions = {
      loop: this.isQuickshop,
      slidesPerView: 1,
      threshold: 5,
      observer: true,
      observeParents: true,
      ...(this.isQuickshop) && {
        spaceBetween: 16
      }
    }

    swiperOptions.pagination = {
      el: paginationEl,
      clickable: true,
      type: 'bullets'
    }

    return new Swiper(this, swiperOptions)
  }

  set selectedVariant (variantJson) {
    this.variantData = variantJson
    if (!this.variantData) { return }

    if (!this.swiper) {
      this.initCarouselGallery()
      return
    }

    if (this.isFilterItemsByColor === 'true') {
      this.filteredSlides = this.filterItemsByColor()

      // Update main slider
      this.swiper.removeAllSlides()
      this.swiper.appendSlide(this.filteredSlides)
      this.swiper.update()
      this.swiper.slideTo(0, false)
    } else {
      const matchingMediaItem = [...this.mediaEls].find(mediaItem => mediaItem.dataset.variantIds?.includes(variantJson.id))
      if (!matchingMediaItem) { return }
      const slideIndex = Number(matchingMediaItem.dataset.itemIndex)
      this.swiper.slideTo(slideIndex, false)
    }
  }

  get selectedVariant () {
    return this.variantData
  }
}

if (typeof window.customElements.get('product-gallery-carousel') === 'undefined') {
  window.customElements.define('product-gallery-carousel', productGalleryCarousel)
}

const productGalleryGrid = class extends HTMLElement {
  constructor() {
    super()

    this.parentProductEl = this.closest('product-wrap')
    this.isQuickshop = this.parentProductEl.classList.contains('product--quickshop')
    this.imageLimit = this.isQuickshop ? 5 : 4

    this.gridItems = this.querySelectorAll('[data-grid-gallery-item]')
    this.colorOptionIndex = this.dataset.colorOptionIndex
    this.isFilterItemsByColor = this.dataset.filterByColor === 'true'
    this.variantColor = this.dataset.currentColor

    this.viewMoreWrapper = this.querySelector('[data-grid-gallery-view-more-wrapper]')
    this.viewMoreButton = this.querySelector('[data-grid-gallery-view-more]')

    this.viewLessWrapper = this.querySelector('[data-grid-gallery-view-less-wrapper]')
    this.viewLessButton = this.querySelector('[data-grid-gallery-view-less]')
  }

  connectedCallback() {
    this.viewMoreButton && this.viewMoreButton.addEventListener('click', () => {
      this.updateGrid(true)
    })

    this.viewLessButton && this.viewLessButton.addEventListener('click', () => {
      this.updateGrid(false)
    })
  }

  updateGrid (viewingMore = false) {
    let shownCount = 0
    if (!this.variantColor || this.isFilterItemsByColor === false) {
      this.gridItems.forEach((gridItem) => {
        gridItem.classList.toggle('hide', shownCount >= this.imageLimit && !viewingMore)
        gridItem.classList.remove('first-visible')
        shownCount++
      })

      const firstVisibleGridItem = [...this.gridItems].find(item => !item.classList.contains('hide'))
      firstVisibleGridItem.classList.add('first-visible')

      const showViewMore = Boolean(viewingMore === false && shownCount > this.imageLimit)
      if (this.viewMoreWrapper) {
        this.viewMoreWrapper.classList.toggle('hide', !showViewMore)
        this.viewLessWrapper.classList.toggle('hide', !(viewingMore === true && shownCount > this.imageLimit))
      }
      this.setAttribute('data-shown-images', shownCount)
      return
    }


    this.gridItems.forEach((gridItem) => {
      const itemAltSplit = gridItem.dataset.altText.split('|')
      const itemColor = itemAltSplit.length > 1 ? itemAltSplit[0].trim() : false
      const showItem = !itemColor || itemColor.toLowerCase() === this.variantColor.toLowerCase()
      gridItem.classList.toggle('hide', !showItem || (shownCount >= this.imageLimit && !viewingMore))
      gridItem.classList.remove('first-visible')
      if (gridItem.hasAttribute('data-fancybox')) {
        gridItem.setAttribute('data-fancybox', showItem ? this.dataset.id : 'hidden')
      }
      if (showItem) shownCount++
    })

    const firstVisibleGridItem = [...this.gridItems].find(item => !item.classList.contains('hide'))
    firstVisibleGridItem.classList.add('first-visible')

    const showViewMore = Boolean(viewingMore === false && shownCount > 4)
    if (this.viewMoreWrapper) {
      this.viewMoreWrapper.classList.toggle('hide', !showViewMore)
      this.viewLessWrapper.classList.toggle('hide', !(viewingMore === true && shownCount > this.imageLimit))
    }
    this.setAttribute('data-shown-images', shownCount)
  }

  set selectedVariant (variantJson) {
    this.variantData = variantJson
    if (variantJson) {
      this.variantColor = variantJson[`option${this.colorOptionIndex}`]
    }
    this.updateGrid()
  }

  get selectedVariant () {
    return this.variantData
  }
}

if (typeof window.customElements.get('product-gallery-grid') === 'undefined') {
  window.customElements.define('product-gallery-grid', productGalleryGrid)
}
